import { Button } from "antd";
import srkPartnerJson from "./srkPartnership.json";
import { iconsAndImages } from "../../assets/images";
import "./partnershipStyle.scss";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa6";

export const SrkPartnership = () => {
    const navigate = useNavigate();
    return (
        <section className="partnership-section py-5">
            <div className="container">
                <div className="text-center mx-auto partnership-wrapper">
                    <div className="d-flex justify-content-center mb-3">
                        <div className="partner-icon rounded-circle d-flex align-items-center justify-content-center">
                            <img
                                loading="lazy"
                                src={iconsAndImages[srkPartnerJson?.srkConversationIcon]}
                                alt="conversation"
                                className="img-fluid"
                            />
                        </div>
                    </div>
                    <h1 className="bebas-neue-regular fw-normal partnership-title">
                        {srkPartnerJson?.title}
                    </h1>
                    <p
                        className="partnership-desc mb-4"
                        dangerouslySetInnerHTML={{
                            __html: srkPartnerJson?.subContent,
                        }}
                    />
                    <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
                        <Button type="primary" size="large" onClick={() => navigate("/contact")}>
                            {srkPartnerJson?.conversation}
                        </Button>

                        <Button size="large" icon={<FaArrowRight />} onClick={() => navigate("/products")}>
                            {srkPartnerJson?.catalog}
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    );
};